import { GenericAdmiralFields } from '../Components';

/**
 * These are admiral questions that are PII, but we are ok exposing them to internal domains. In the translation layer (i.e. for external domains we will obfuscate the value of the field - instead of in chameleon). We are ok doing that as we are only exposing them to internal domains.
 */
export const admiralQuestionPiiQuestionAnsweredExclusionList = [
  GenericAdmiralFields.PRIMARY_ADDRESS_CITY,
  GenericAdmiralFields.PRIMARY_ADDRESS_STATE,
  GenericAdmiralFields.PRIMARY_ADDRESS_POSTCODE,
  GenericAdmiralFields.POSTCODE,
];

const admiralQuestionsContainingPii = [
  GenericAdmiralFields.YOUR_FIRST_NAME,
  GenericAdmiralFields.FIRST_NAME,
  GenericAdmiralFields.LAST_NAME,
  GenericAdmiralFields.PHONE_HOME,
  GenericAdmiralFields.PHONE_MOBILE,
  GenericAdmiralFields.PHONE_WORK,
  GenericAdmiralFields.PHONE_FAX,
  GenericAdmiralFields.PHONE_OFFICE,
  GenericAdmiralFields.MOBILE_NUMBER,
  GenericAdmiralFields.COMPANY_NAME,
  GenericAdmiralFields.POSTCODE,
  GenericAdmiralFields.PRIMARY_ADDRESS_POSTCODE,
  GenericAdmiralFields.PRIMARY_ADDRESS_STREET,
  GenericAdmiralFields.PRIMARY_ADDRESS_STATE,
  GenericAdmiralFields.PRIMARY_ADDRESS_CITY,
  GenericAdmiralFields.EMAIL,
];

export default admiralQuestionsContainingPii;
